import { GzDoubleColumnDetailsWebComponent } from './component/GzDoubleColumnDetailsWebComponent';

export { GzDoubleColumnDetailsWebComponent };
